import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Drawer from "../../components/ui/Drawer";
import { ButtonGroup, Button } from "../../components/ui/buttons/Button";

import "./file-upload.scss";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { transferFund } from "../../api/card-service";

const TransferFundDrawer = ({ id, title, onClose, cardItem }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset();
  }, []);

  const cardLoad = async (payload) => {
    setLoading(true);
    transferFund(payload)
      .then((res) => {
        setLoading(false);
        toast(res.data.message, {
          type: "success",
        });
        reset();
        onClose();
      })
      .catch((error) => {
        setLoading(false);
        reset();
        onClose();
      });
  };

  const handleFormSubmit = (formData) => {
    const payload = {
      // form input details
      amount: formData.amount,
      orderId: formData.orderId,
      cashReceiptVoucher: formData.cashReceiptVoucher,

      // additional details
      fromUserHashId: currentUser.userHashId,
      clientHashId: currentUser.clientHashId,
      userType: currentUser.productType,

      programHashId: cardItem.programHashId,
      toUserHashId: cardItem.userHashId,
      customerHashId: cardItem.customerHashId,
      moxeyId: cardItem.moxeyId,
      currency: cardItem.currency,
      countryCode: cardItem.countryCode,

      firstName: cardItem.firstName,
      lastName: cardItem.lastName,
      firstArabicName: cardItem.firstNameInArabic,
      mobileNo: cardItem.mobileNumber,
      Status: cardItem.cardStatus,
      maskCardNumber: cardItem.maskCardNumber,
    };

    cardLoad(payload);
  };

  return (
    <>
      <Drawer title={title} id={id} onClose={onClose}>
        <>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <fieldset disabled={loading}>
              <div className="row">
                {/* Moxey Id */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="order-id" className="form-label">
                      Moxey Id
                    </label>
                    <input
                      type="text"
                      id="order-id"
                      className="form-control disabled"
                      value={cardItem.moxeyId}
                      disabled
                    />
                  </div>
                </div>
                {/* Moxey Id */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="order-id" className="form-label">
                      Driver Name
                    </label>
                    <input
                      value={`${cardItem.firstName} ${cardItem.lastName}`}
                      type="text"
                      id="order-id"
                      className="form-control disabled"
                      disabled
                    />
                  </div>
                </div>
                {/* Moxey Id */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="order-id" className="form-label">
                      Selected Currency
                    </label>
                    <select
                      value={cardItem.currency}
                      className="form-select"
                      {...register("currency", {
                        required: true,
                        disabled: true,
                      })}
                    >
                      <option selected value="AED">
                        AED
                      </option>
                    </select>
                  </div>
                </div>
                {/* Enter Amount */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="orderId" className="form-label">
                      Order Id
                    </label>
                    <input
                      type="text"
                      id="orderId"
                      step=".01"
                      className={`form-control ${
                        errors.orderId && "is-invalid"
                      }`}
                      {...register("orderId", {
                        required: {
                          value: true,
                          message: "Required Field",
                        },
                      })}
                    />
                    <div class="invalid-feedback">
                      {errors.orderId && errors.orderId.message}
                    </div>
                  </div>
                </div>

                {/* Transfer Amount */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="amount" className="form-label">
                      Transfer Amount
                    </label>
                    <input
                      type="text"
                      id="amount"
                      className={`form-control ${
                        errors.amount && "is-invalid"
                      }`}
                      {...register("amount", {
                        required: {
                          value: true,
                          message: "Required Field",
                        },
                        pattern: {
                          value: /^(?!0(?:\.0{1,2})?$)\d+(\.\d{1,2})?$/,
                          message:
                            "Only positive numbers (up to 2 decimal places are allowed)",
                        },
                      })}
                    />
                    <div class="invalid-feedback">
                      {errors.amount && errors.amount.message}
                    </div>
                  </div>
                </div>

                {/* Cash Receipt Voucher */}
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="mb-3">
                    <label for="cashReceiptVoucher" className="form-label">
                      Cash Receipt Voucher
                    </label>
                    <input
                      type="text"
                      id="cashReceiptVoucher"
                      className={`form-control ${
                        errors.cashReceiptVoucher && "is-invalid"
                      }`}
                      {...register("cashReceiptVoucher", {
                        required: {
                          value: true,
                          message: "Required Field",
                        },
                      })}
                    />
                    <div class="invalid-feedback">
                      {errors.cashReceiptVoucher &&
                        errors.cashReceiptVoucher.message}
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <ButtonGroup>
              <Button
                loading={loading}
                className="btn btn-primary"
                text={"Request"}
              />
              <Button
                className="btn btn-light"
                text={"Cancel"}
                onClick={onClose}
              />
            </ButtonGroup>
          </form>
        </>
      </Drawer>
    </>
  );
};

export default TransferFundDrawer;
